<template>
  <div class="container-fluid">
    <div class="flex-center-space-between">
      <div class="mr-1" style="width:50%">
        <div class="card">
          <div class="card-header">
            Nous contacter
          </div>
          <div class="card-container">
            <div class="card card-minimal table-scroll height-responsive-top-50">
              <h5 class="mb-2 mt-4"><a :href="'tel:'+ contactService?.telephoneFixe"><i class="fas fa-phone-square mr-2 ml-2"></i>{{ contactService?.telephoneFixeFormat }}</a></h5>
              <h5 class="mb-2"><a :href="'mailto:' + contactService?.email"><i class="fas fa-envelope mr-2 ml-2"></i>{{ contactService?.email }}</a></h5>
              <br/>
              <h5 class="m-2">{{ equipeContact }} :</h5>
              <template v-for="(contact, iContact) in listePersonne" >
                <span :key="'contact-'+iContact">
                  <h5 class="mt-2 mb-2"><a :href="'mailto:' + contact.email" ><i class="fas fa-user mr-2 ml-2"></i>{{ contact.prenomNom }} - {{ contact.email }}</a></h5>
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-1" style="width:50%">
        <div class="card">
          <div class="card-header">
            Informations
          </div>
          <div class="card-container">
            <div class="card card-minimal table-scroll height-responsive-top-50">
              <span class="flex-center-center mt-2"><h4>Bienvenue sur votre nouvel espace fournisseur</h4></span>
              <span class="flex-center-center"><h5 class="mt-2 m-3">Ce site vous permet de gérer vos propositions de tarifs ainsi que l'ensemble de vos informations</h5></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-center-space-between">
      <div class="mr-1" style="width:100%">
        <div class="card">
          <div class="card-header">
            Prochaine date de mise à jour
          </div>
          <div class="card-container">
            <div class="card card-minimal table-scroll height-responsive-top-50">
              <div v-if="etatAvancement?.etatAvancement?.length > 0">
                <span class="flex-center-center mt-3 mb-3"><h5>{{ formatHumanDateAvecJour(etatAvancement.dateActivation) }}</h5></span>  
                <table id="tableauEtatAvancement" class="table table-sm text-center" v-no-dragdrop>
                  <colgroup>
                    <col width="250">
                    <col width="150">
                    <col>
                    <col width="35">
                  </colgroup>
                  <thead class="table-header-secondary">
                    <th>Familles</th>
                    <th>Propositions Attendues</th>
                    <th>Avancement / Statut</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <template v-for="(avancement, iAvancement) in etatAvancement.etatAvancement.first().etatAvancementFamilles">
                      <tr :key="'avancementFamille-'+iAvancement">
                        <td v-no-dragdrop>
                          {{ avancement.famille.nom }} ({{ avancement.famille.code }})
                        </td>
                        <td v-no-dragdrop>
                          {{ avancement.nombrePropositionsAttendues }}
                        </td>
                        <td>
                          <div style="width:100%" class="flex-center-center">
                            <template v-for="(statut, iStatut) in avancement.etatAvancementPropositions">
                              <span class="card-statut-header flex-center-center" :title="statut.nomStatut" :key="'statut' + iAvancement + '-' + iStatut" :style="styleStatut(statut, statut.nombrePropositions, avancement.nombrePropositionsAttendues)">
                                {{ statut.nombrePropositions }}
                              </span>  
                            </template>  
                          </div>
                        </td>
                        <td>
                          <button class="btn btn-primary btn-sm" :title="'Ouvrir la page des propositions tarifaire'" @click="ouvrirPageTarifs(avancement.famille.familleId)"><i class="fas fa-share"></i></button>
                        </td>
                      </tr>
                    </template>
                  </tbody>


                </table>
                
              </div>
              <div v-else>
                <span class="flex-center-center mt-3"><h5>Aucune date de propositions ouverte</h5></span>  
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import { connecteData } from "@/mixins/connecteData"
import { getContactsAgapDunFournisseur } from '@/api/gpao/user'
import { obtenirEtatAvancement } from '@/api/gpao/propositions'
import { plurielUC, arrondiNombre, couleurHexCss } from '../helpers/utils'
import { formatageDate } from '../mixins/dateFormats'

export default {
  name: "Home",
  mixins: [connecteData, formatageDate],
  components: {},
  data() {
    return {
      informations: [],
      listeContacts: [],
      listePersonne: [],
      etatAvancement: [],
      contactService: {}
    }
  },
  computed: {
    equipeContact() {
      return (this.listePersonne.length > 1 ? "Vos ": "Votre ") + plurielUC(this.listePersonne.length," interlocuteur") + plurielUC(this.listePersonne.length," privilégié")
    }
  },
  async mounted() {
    this.obtenirContacts()
  },
  methods: {
    ...mapActions("uxHelpers", ["cacherAttente"]),

    async obtenirContacts() {
      let response = await getContactsAgapDunFournisseur(this.fournisseurCourantId)
      this.listeContacts = response.data
      this.contactService = this.listeContacts.filter(x => x.prenom === "Service").first()
      this.listePersonne = this.listeContacts.filter(x => x.prenom !== "Service") || []

      let etat = await obtenirEtatAvancement(this.fournisseurCourantId)
      this.etatAvancement = etat.data
      //On recoit l'état d'avancement de ce fournisseur.
      //La liste EtatAvancement ne doit contenir qu'un seul enregistrement, donc on peut prendre la premiere valeur
      //Si aucune Date, la liste est vide.
    },
    calculPourcentageStatut(nombre, total) {
      return arrondiNombre(nombre * 100/total, 0) < 15 ? 15 : arrondiNombre(nombre * 100/total, 0)
      //return arrondiNombre(nombre * 100/total, 0)
    },
    styleStatut(statut, quantite, total) {
      if (!quantite && quantite !== 0)
        quantite = statut.nombrePropositions

      return 'color:black; width:' + this.calculPourcentageStatut(quantite, total) + '%; ' + ' background-color:' + couleurHexCss(statut.statut.codeCouleur, 25)
    },
    ouvrirPageTarifs(famId) {
      //Ouvre la page des tarifs pour la prochaine date
      this.$router.push({name: 'PropositionsMercuComparative', params: { fournisseurId: this.fournisseurCourantId }, query: {propositionId: this.etatAvancement.propositionId, familleId: famId }})
    },

  }
}
</script>
